/* eslint-disable react-hooks/exhaustive-deps */
/* แจ้ง RC แทนลูกค้า (ลูกค้าโทรมา / คุยหน้างาน) — สถานะเริ่มที่ "รับเรื่องแล้ว" */
import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Radio, Select, message } from "antd";
import FilePicker from "../../../components/ak/FilePicker";
import { RC_TYPES, RC_TYPE_HINT } from "../../../components/ak/rc";
import { RcService, apiError } from "../../../service/Ak.service";
import OptionService from "../../../service/Options.service";

const opt = OptionService();

export default function RcCreateModal({ open, projectCode, onClose, onDone }) {
  const [form] = Form.useForm();
  const [files, setFiles] = useState([]);
  const [projects, setProjects] = useState([]);
  const [saving, setSaving] = useState(false);
  const type = Form.useWatch("rc_type", form);

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    setFiles([]);
    if (!projectCode && !projects.length) opt.projects().then((r) => setProjects(r.data?.data || []));
  }, [open]);

  const save = async () => {
    const v = await form.validateFields();
    setSaving(true);
    try {
      const r = await RcService.create({ ...v, project_code: projectCode || v.project_code }, files);
      message.success(`บันทึก ${r.data.data.rc_code} แล้ว`);
      onDone?.(r.data.data);
    } catch (e) {
      message.error(apiError(e, "บันทึกไม่สำเร็จ"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} title="แจ้ง RC แทนลูกค้า" onCancel={onClose} onOk={save} okText="บันทึก" cancelText="ยกเลิก" confirmLoading={saving} width={640} destroyOnClose>
      <Form form={form} layout="vertical" initialValues={{ rc_type: RC_TYPES[0] }}>
        {!projectCode && (
          <Form.Item name="project_code" label="โปรเจ็กต์" rules={[{ required: true, message: "เลือกโปรเจ็กต์" }]}>
            <Select
              showSearch
              optionFilterProp="label"
              options={projects.filter((p) => p.status !== "ยกเลิก").map((p) => ({ value: p.value, label: `${p.label}${p.cus_name ? ` · ${p.cus_name}` : ""}` }))}
            />
          </Form.Item>
        )}
        <Form.Item name="rc_type" label="ประเภท" extra={RC_TYPE_HINT[type]}>
          <Radio.Group optionType="button" buttonStyle="solid" options={RC_TYPES.map((t) => ({ value: t, label: t }))} />
        </Form.Item>
        <Form.Item name="title" label="หัวข้อ" rules={[{ required: true, message: "กรอกหัวข้อ" }]}>
          <Input maxLength={200} placeholder="เช่น ขอเพิ่มปลั๊กไฟห้องนอนใหญ่ 2 จุด" />
        </Form.Item>
        <Form.Item name="detail" label="รายละเอียด">
          <Input.TextArea rows={4} maxLength={4000} />
        </Form.Item>
      </Form>
      <FilePicker value={files} onChange={setFiles} compact />
    </Modal>
  );
}
